import { IEnvironment } from '@services/infra/i-environment';
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --production` replaces `environment.ts` with `environment.docker.ts`.
// The list of file replacements can be found in `angular.json`.

// this file is used for deployment on master and prod stage to extend the dynamic config variables
// with 'static' stage dependent environment variables
export const environment: IEnvironment = {
  production: (window as any).env.production || false,
  localConfig: null,
  enableMockData: false,
  enableMockLogin: false,
  clientIdAuth0: (window as any).env.clientIdAuth0 || '',
  identityProviderUrl: (window as any).env.identityProviderUrl || '',
  allowedBackendUrls: (window as any).env.allowedBackendUrls || '',
  externalCss: (window as any).env.externalCss || '',
  maintenanceMode: (window as any).env.maintenanceMode || false,
  maintenanceForRegistration: (window as any).env.maintenanceForRegistration || false,
  freshdeskWidgetId: (window as any).env.freshdeskWidgetId || '103000008679',
  freshdeskRegistrationWidgetId: (window as any).env.freshdeskRegistrationWidgetId || '103000008678',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// NOSONAR
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
